(function () {
  if (window.QLSCartCountRepairV139Loaded) return;
  window.QLSCartCountRepairV139Loaded = true;

  var timer = 0;
  var requestId = 0;
  var observerPaused = false;
  var protectionTerms = [
    'quality shipping protection',
    'shipping protection',
    'simply shipping protection',
    'route package protection',
    'package protection'
  ];

  function isProtection(item) {
    var text = [
      item && item.title, item && item.product_title, item && item.variant_title,
      item && item.handle, item && item.url, item && item.sku,
      item && item.vendor, item && item.product_type
    ].join(' ').toLowerCase();
    return protectionTerms.some(function (term) { return text.indexOf(term) !== -1; });
  }

  function cleanCount(cart) {
    var config = document.querySelector('[data-qls-shipping-protection-config]');
    var exclude = !config || config.dataset.excludeFromCartCount !== 'false';
    if (!exclude) return Number(cart.item_count) || 0;
    return (cart.items || []).reduce(function (sum, item) {
      return sum + (isProtection(item) ? 0 : (Number(item.quantity) || 0));
    }, 0);
  }

  function cartHosts() {
    var hosts = Array.prototype.slice.call(document.querySelectorAll('#cart-icon-bubble'));
    document.querySelectorAll('#cart-icon').forEach(function (icon) {
      if (!icon.querySelector('#cart-icon-bubble')) hosts.push(icon);
    });
    return hosts;
  }

  function render(count) {
    observerPaused = true;
    document.documentElement.classList.add('qls-cart-badge-ready');
    document.documentElement.classList.remove('qls-cart-badge-settling', 'qls-cart-badge-mask');

    cartHosts().forEach(function (host) {
      var bubble = host.querySelector('.header__cart-count');
      if (count < 1) {
        if (bubble) bubble.remove();
        return;
      }
      if (!bubble) {
        bubble = document.createElement('div');
        bubble.className = 'header__cart-count absolute bg-theme-text text-theme-bg text-center';
        bubble.innerHTML = '<span aria-hidden="true" class="header__cart-count-number"></span>' +
          '<span class="visually-hidden"></span>';
        host.appendChild(bubble);
      }
      var visible = bubble.querySelector('.header__cart-count-number, span[aria-hidden="true"]');
      var accessible = bubble.querySelector('.visually-hidden');
      if (visible) visible.textContent = String(count);
      if (accessible) accessible.textContent = count === 1 ? '1 item in cart' : count + ' items in cart';
      bubble.classList.remove('hidden');
      bubble.removeAttribute('hidden');
      bubble.removeAttribute('aria-hidden');
      bubble.style.removeProperty('opacity');
      bubble.style.removeProperty('visibility');
    });

    document.querySelectorAll('#cart-icon, a[href="/cart"]').forEach(function (link) {
      link.setAttribute('aria-label', count === 1 ? 'Cart, 1 item' : 'Cart, ' + count + ' items');
    });
    window.setTimeout(function () { observerPaused = false; }, 0);
  }

  function refresh() {
    var currentRequest = ++requestId;
    fetch('/cart.js', {
      credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }
    })
      .then(function (response) { return response.ok ? response.json() : Promise.reject(); })
      .then(function (cart) { if (currentRequest === requestId) render(cleanCount(cart)); })
      .catch(function () {});
  }

  function schedule(delay) {
    window.clearTimeout(timer);
    timer = window.setTimeout(refresh, typeof delay === 'number' ? delay : 80);
  }

  ['ssp:cart:update', 'cart:updated', 'cart:refresh', 'cart-drawer:updated',
    'dispatch:cart-drawer:refresh', 'on:cart:add', 'shopify:section:load'].forEach(function (name) {
    document.addEventListener(name, function () { schedule(60); });
  });

  document.addEventListener('click', function (event) {
    if (event.target.closest('button[name="add"], [name="plus"], [name="minus"], [data-remove], .quantity__button, .cart-item__remove')) {
      schedule(180);
      window.setTimeout(refresh, 700);
    }
  }, true);

  new MutationObserver(function (mutations) {
    if (observerPaused) return;
    var relevant = mutations.some(function (mutation) {
      var target = mutation.target;
      return target && target.nodeType === 1 && (
        target.matches('#cart-icon, #cart-icon-bubble, cart-drawer, #cart-drawer, .drawer--cart') ||
        target.querySelector('#cart-icon, #cart-icon-bubble, cart-drawer, #cart-drawer, .drawer--cart')
      );
    });
    if (relevant) schedule(40);
  }).observe(document.documentElement, { childList: true, subtree: true });

  var nativeFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var url = String(args[0] && args[0].url ? args[0].url : args[0] || '');
    return nativeFetch.apply(this, args).then(function (response) {
      if (/\/cart\/(add|change|update|clear)(?:\.js)?(?:\?|$)/.test(url)) schedule(40);
      return response;
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();
  window.setTimeout(refresh, 500);
  window.setTimeout(refresh, 1600);
})();
